import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

const NewUserRoute = ({ children }) => {
  const { authed } = useAuth();
  const location = useLocation();

  if (authed) {
    return <Navigate to="/" replace state={{ path: location.pathname }} />;
  }
  return children;
};

export default NewUserRoute;
